import Routes from "@/router/routes";

export default {
  methods: {
    goToSettings() {
      this.$router.push({name: Routes.ACCOUNT_ROUTE});
    },
  }
}